export default "__VITE_ASSET__DLA86tY1__"